// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"28":"558c4ce1a6379621abc3","138":"83465b35d71469a52113","147":"206ce6dc54cdba1a467a","251":"cccaad9d45d20ef7e70f","352":"bd48fa357530d4e8358a"}[chunkId] + ".js";
};